export class Organization {
  id: string = "";
  name: string = "";
}
